import axios from '@/libs/axios'

export default {
  getReviewRequests: params => axios.get('/order-requests/review', { params }),
  getReviewStatusTotals: params => axios.get('/order-requests/review/status-totals', { params }),
  getReviewRequestById: id => axios.get(`/order-requests/${id}`),
  acceptReviewRequest: (id, payload) => axios.post(`/order-requests/${id}/accept`, payload),
  rejectReviewRequest: (id, payload) => axios.post(`/order-requests/${id}/reject`, payload),
  requestChangesReviewRequest: (id, payload) => axios.post(`/order-requests/${id}/request-changes`, payload),
}
